<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="showDocuments ? 'd-none' : ''"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!-- table-->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- privateNumberPrice Title -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.privateNumberPriceTitle"
          ></td-value>
        </td>

        <!-- number -->
        <td>
          <td-value copyToClipboard [value]="item?.number"></td-value>
        </td>

        <!-- organizationName -->
        <td>
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- payAmount -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value
            copyToClipboard
            type="number"
            [value]="item?.payAmount"
          ></td-value>
        </td>

        <!-- privateNumberPriceNumberOfDigits -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value
            copyToClipboard
            type="number"
            [value]="item?.privateNumberPriceNumberOfDigits"
          ></td-value>
        </td>

        <!-- privateNumberPriceIsRound -->
        <td>
          <td-value
            type="boolean"
            [value]="item?.privateNumberPriceIsRound"
          ></td-value>
        </td>

        <!-- smsCp -->
        <td>
          <span
            [smsSenderAgent]="item?.privateNumberPriceSmsCp"
            copyToClipboard
            >{{
              item?.privateNumberPriceSmsCp | enumToText : SmsCpEnumValues
            }}</span
          >
        </td>

        <!-- isService -->
        <td>
          <td-value type="boolean" [value]="item?.isService"></td-value>
        </td>

        <!-- private Number Buy Request -->
        <td class="dir-rtl tw-text-center tw-px-1">
          <span
            [privateNumberBuyRequestStatus]="
              item?.privateNumberBuyRequestStatus
            "
            [matTooltip]="
              item?.privateNumberBuyRequestStatus
                | enumToText : PrivateNumberBuyRequestStatusEnumValues
            "
          >
          </span>
        </td>

        <!-- rejectionDescription -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.rejectionDescription"
          ></td-value>
        </td>

        <!-- assignmentDate -->
        <td>
          <td-value
            type="dateTimeWithSpace"
            [value]="item?.assignmentDate"
          ></td-value>
        </td>

        <!-- reservationDate -->
        <td>
          <td-value
            type="dateTimeWithSpace"
            [value]="item?.reservationDate"
          ></td-value>
        </td>

        <!-- cancellationDate -->
        <td>
          <td-value
            type="dateTimeWithSpace"
            [value]="item?.cancellationDate"
          ></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <!-- open menu btn -->
          <div
            app-menu-btn
            [matMenuTriggerFor]="menu"
            [isShowDotsMenu]="true"
          ></div>

          <!-- menu -->
          <mat-menu #menu="matMenu" xPosition="before">
            <!-- edit button -->
            <div
              app-menu-btn
              *ngIf="
                userSession.organizationId() == 1 &&
                item?.privateNumberBuyRequestStatus !=
                  PrivateNumberBuyRequestStatus.CertainAssignment
              "
              icon="edit"
              title="common.editStatus"
              (click)="
                onUpdateStatus(
                  item?.id,
                  item?.privateNumberBuyRequestStatus,
                  item?.privateNumberPriceSmsCp
                )
              "
            ></div>

            <!-- documentation button -->
            <div
              app-menu-btn
              icon="mdi mdi-folder-account-outline mdi-20px"
              color="indigo"
              [title]="'common.documentation' | translate"
              (click)="onShowDocuments(item?.id, item?.organizationId)"
            ></div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- add or update form -->
<!-- <ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-private-numbers-price-form [formPageConfig]="formPageConfig" (closeFormPage)="getFormResponse($event)">
  </app-private-numbers-price-form>
</ng-container> -->

<!--------------------------------------------------------------- documentations ---------------->

<!--  documents  -->
<ng-container *ngIf="showDocuments">
  <app-private-number-documentation
    [documentationTypes]="DocumentationTypeEnumValues"
    [childOrganizationId]="childOrganizationId"
    [requestId]="requestId"
    (closeFormPage)="
      showDocuments = false; showParent = true; getParentQueryString()
    "
  >
  </app-private-number-documentation>
</ng-container>

<!--------------------------------------------------------------- Audit ---------------->

<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
